import React from "react";
import { Query } from "react-apollo";
import {
  getFournisseurs,
  getTransactions
} from "../../api/queries/transactions.queries";
import Loader from "./Loader";
import moment from "moment";
import { useAuthState } from "../Context";

function Fournisseurs(props) {
  const authContext = useAuthState(); //read user de
  const { userDetails = {} } = authContext;
  const {
    id: utilisateurId,
    login,
    email,
    token,
    entreprises = []
  } = userDetails;

  console.log({ entreprises });
  const entreprise = entreprises[0].entrepriseId;

  return (
    <Query query={getFournisseurs} variables={{ utilisateurId, entreprise }}>
      {({
        loading: loadingFournisseurs,
        error: errorFournisseurs,
        data: dataFournisseurs = {},
        refetch: refetchFournisseurs
      }) => {
        if (loadingFournisseurs) return <Loader />;
        const fournisseurs = [];

        if (dataFournisseurs.getFournisseurs) {
          if (dataFournisseurs.getFournisseurs.length) {
            dataFournisseurs.getFournisseurs.forEach(fournisseur => {
              fournisseurs.push({
                label: fournisseur.name,
                value: fournisseur.id
              });
            });
          }
        }

        return (
          <div>
            <h1 className="dashboardTitle">Fournisseurs</h1>
            <ul className="listFournisseurs">
              {fournisseurs.map(
                fo =>
                  fo.label && (
                    <li key={fo.id} className="fournisseur">
                      {`${fo.label[0].toUpperCase()}${fo.label.slice(1)}`}
                    </li>
                  )
              )}
            </ul>
          </div>
        );
      }}
    </Query>
  );
}

export default Fournisseurs;
